import reducers from './reducers';
import {createStore, applyMiddleware} from 'redux';
import {persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage';
// import logger from 'redux-logger'
import thunk from 'redux-thunk'

const persistConfig = {
    key: 'root',
    storage,
    // blacklist: ['userState'],
    // whitelist: ['userState'],

}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store  = createStore(persistedReducer,  applyMiddleware(thunk));
export const persistor  =  persistStore(store); 